module.exports = "../fonts/n-a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/n-a.svg
// module id = IQ/s
// module chunks = 1